var React = require('react');

function CheckBoxDisable (props) {
    return React.createElement("svg",props,React.createElement("rect",{"width":"16","height":"16","fill":"#F2F3F3","fillRule":"evenodd","stroke":"#E5E7E8","rx":"2"}));
}

CheckBoxDisable.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = CheckBoxDisable;

CheckBoxDisable.default = CheckBoxDisable;
